import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormLabel,
  IconButton,
  Paper,
  Radio,
  InputAdornment,
  Breadcrumbs,
  Link,
  Modal,
  Fade,
  Snackbar,
  Alert,
  MenuItem,
  ListItemText,
  CircularProgress,
  Backdrop,
} from "@mui/material";

function AddUserManagement (){

    return(
        <Box sx={{padding:{ xs: "80px 20px 20px 20px", sm: "70px 30px 20px 80px" }}}>

        </Box>
    )

}
export default AddUserManagement